import React from 'react';
import {isEmpty,isEqual} from 'lodash'
import { ELEMENT_TYPES } from '../constants/ActionTypes';
import Workflow from './workflow/';
import MyCalendar from './mycalendar/';
//import MyCalendar from './mycalendar_fs/';
import Rss from './rss/';
import CustomPage from './custompage/';
import News from './news/';
import ReportForm from './reportform/';
import OutData from './outdata/';
import FormModeCustomSearch from './formmodecustomsearch/';
import Picture from './picture/';
import View from './view/';
import MoreNews from './morenews/';
import Stock from './stock/';
import Magazine from './magazine/';
import DocContent from './doccontent/';
import Audio from './audio/';
import Favourite from './favourite/';
import Flash from './flash/';
import ImgSlide from './imgslide/';
import DataCenter from './datacenter';
import Video from './video/';
import Weather from './weather';
import OutterSys from './outtersys/';
import Scratchpad from './scratchpad/';
import Slide from './slide/';
import JobsInfo from './jobsinfo/';
import SearchEngine from './searchengine/';
import CustomMenu from './custommenu/';
import Notice from './notice/';
import Mail from './mail/';
import CoreMail from './coremail/';
import BlogStatus from './blogstatus/';
import Contacts from './contacts/';
import AddWf from './addwf/';
import Task from './task/';
import NewNotice from './newnotice/';
import WorkTask from './worktask/';
import FnaBudgetAssistant from './fnaBudgetAssistant';
import FnaBudgetAssistant1 from './fnaBudgetAssistant1';
//import Plan from './plan/';
import NoReact from './noreact/';
import Cooperation from './cooperation/';
import MeetingCalendar from './meetingcalendar';
import MyProjects from './myprojects';
import LoginNews from './loginnews';
//登录前门户元素
import Login from './login/';
//最新会议元素
import NewMeeting from './newmeeting';
//每日计划元素
import DayPlan from './dayplan';
//我的任务元素
import ProcessTask from './processtask';
//未读文档元素
import UnreadDocs from './unreaddocs';
//最新客户元素
import NewCustomers from './newcustomers';
//消息提醒元素
import MessageReminding from './messagereminding/';
//宁波市中级人民法院文档中心元素
import News_dy from './news_dy/';
/*//通用列表组件
import ElementTable from './elementtable/';*/
//自定义元素
import CustomElement from './customelement/';

export default class Element extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            fontSizeMp: {}
        }
        this.getElementStyle = this.getElementStyle.bind(this);
    }

    getElementStyle(id, fontSizeMp){
        const { config } = this.props;
        const { eid } = config.item;
        if(!isEmpty(fontSizeMp) && id == eid){
            this.setState({
                fontSizeMp: fontSizeMp
            })
        }
    }

    shouldComponentUpdate(nextProps, nextState){
        return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
    }

    render() {
        const { config } = this.props;
        const { fontSizeMp } = this.state;
        const { eid, ebaseid } = config.item;
        if (/^Custom_/.test(ebaseid)) {
            return <CustomElement key={eid} config={config}/>
        }

        switch (ebaseid) {
            case ELEMENT_TYPES.WORKFLOW:
                return <Workflow key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.RSS:
                return <Rss key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.CUSTOMPAGE:
                return <CustomPage key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.NEWS:
                return <News key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.REPORTFORM:
                return <ReportForm key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.OUTDATA:
                return <OutData key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.FORMMODECUSTOMSEARCH:
                return <FormModeCustomSearch key={eid} config={config} fontSizeMp={fontSizeMp}/>
            //case ELEMENT_TYPES.MESSAGE_REMINDING:
            //case ELEMENT_TYPES.NEW_CUSTOMERS:
            //case ELEMENT_TYPES.NEW_MEETING:
            case ELEMENT_TYPES.MONTH_TARGET:
            //case ELEMENT_TYPES.DAY_PLAN:
            case ELEMENT_TYPES.SUBSCRIBE_KONWLEDG:
            //case ELEMENT_TYPES.UNREAD_DOCS:
            //case ELEMENT_TYPES.UNREAD_COOPERATION:
            //case ELEMENT_TYPES.MY_PROJECTS:
                return <View key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.PICTURE:
                return <Picture key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MORE_NEWS:
                return <MoreNews key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.STOCK:
                return <Stock key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MAGAZINE:
                return <Magazine key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.DOC_CONTENT:
                return <DocContent key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.AUDIO:
                return <Audio key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.FAVOURITE:
                return <Favourite key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.FLASH:
                return <Flash key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.IMGSLIDE:
                return <ImgSlide key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.DATACENTER:
                return <DataCenter key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.VIDEO:
                return <Video key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.WEATHER:
                return <Weather key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.OUTTERSYS:
                return <OutterSys key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.SCRATCHPAD: 
                return <Scratchpad key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.SLIDE:
                return <Slide key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.JOBSINFO:
                return <JobsInfo key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.SEARCHENGINE:
                return <SearchEngine key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.CUSTOMMENU:
                return <CustomMenu key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.NOTICE:
                return <Notice key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MAIL:
                return <Mail key={eid} config={config} fontSizeMp={fontSizeMp} getElementStyle={this.getElementStyle}/>
            case ELEMENT_TYPES.COREMAIL:
                 return <CoreMail key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.BLOGSTATUS:
                return <BlogStatus key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.CONTACTS:
                return <Contacts key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.ADDWF:
                return <AddWf key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.TASK:
                return <Task key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.NEWNOTICE:
                return <NewNotice key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.WORKTASK:
                return <WorkTask key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.FNABUDGETASSISTANT:
                return <FnaBudgetAssistant key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.FNABUDGETASSISTANT1:
                return <FnaBudgetAssistant1 key={eid} config={config} fontSizeMp={fontSizeMp}/>
            // case ELEMENT_TYPES.PLAN:
            //     return <Plan key={eid} config={config}/>
            case ELEMENT_TYPES.MYCALENDAR: 
                return <MyCalendar key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.UNREAD_COOPERATION:
                return <Cooperation key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MEETINGCALENDAR:
                return <MeetingCalendar key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MY_PROJECTS:
                return <MyProjects key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.LOGIN:
                return <Login key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.LOGIN_NEWS:
                return <LoginNews key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.NEW_MEETING:
                return <NewMeeting key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.DAY_PLAN:
                return <DayPlan key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MYTASK:
                return <ProcessTask key={eid} config={config}/>
            case ELEMENT_TYPES.UNREAD_DOCS:
                return <UnreadDocs key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.NEW_CUSTOMERS:
                return <NewCustomers key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.MESSAGE_REMINDING:
                return <MessageReminding key={eid} config={config} fontSizeMp={fontSizeMp}/>
            case ELEMENT_TYPES.NEW_DY:
                return <News_dy key={eid} config={config} fontSizeMp={fontSizeMp}/>
            /*          case ELEMENT_TYPES.ELEMENTTABLE:
                            return <ElementTable key={eid} config={config}/>*/
            default:
                return <NoReact key={eid} config={config} fontSizeMp={fontSizeMp}/>
        }
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/index.js